import React from 'react';
import VisaCard from '@reverbdotcom/commons/design-system/icons/payment-card/visa-payment-card.svg?component';
import MastercardCard from '@reverbdotcom/commons/design-system/icons/payment-card/mastercard-payment-card.svg?component';
import DiscoverCard from '@reverbdotcom/commons/design-system/icons/payment-card/discover-payment-card.svg?component';
import AmexCard from '@reverbdotcom/commons/design-system/icons/payment-card/amex-payment-card.svg?component';
import JCBCard from '@reverbdotcom/commons/design-system/icons/payment-card/jcb-payment-card.svg?component';
import UnknownCard from '@reverbdotcom/commons/design-system/icons/payment-card/error-payment-card.svg?component';
import { RCIcon } from '@reverbdotcom/commons/src/rc/RCIcon';
import {
  core_apimessages_CreditCard_Brand as CreditCardBrand,
  core_apimessages_CreditCard_Brand_Type as CreditCardBrandType,

} from '../schemas/rql';

interface Props {
  brand: CreditCardBrand;
}

export default function CreditCardBrandIcon({ brand }: Props) {
  const type = brand.type.toLowerCase();
  const icon = creditCardIcons[type];

  return (
    <RCIcon
      title={brand.name}
      svgComponent={icon}
    />
  );
}

const creditCardIcons: Record<Lowercase<CreditCardBrandType>, any> = {
  unknown: UnknownCard,
  visa: VisaCard,
  mastercard: MastercardCard,
  discover: DiscoverCard,
  amex: AmexCard,
  jcb: JCBCard,
};
